export const hamilton = [
  [39.304835, -84.512774],
  [39.297585, -84.391125],
  [39.292284, -84.353557],
  [39.292757, -84.315692],
  [39.288379, -84.262461],
  [39.281418, -84.265339],
  [39.276628, -84.256512],
  [39.264805, -84.26129],
  [39.248629, -84.293635],
  [39.235156, -84.299441],
  [39.234351, -84.307228],
  [39.223703, -84.319984],
  [39.209085, -84.310319],
  [39.213521, -84.285463],
  [39.201727, -84.276198],
  [39.188139, -84.287519],
  [39.1817, -84.288733],
  [39.17421, -84.299421],
  [39.167231, -84.295077],
  [39.164433, -84.300117],
  [39.159434, -84.301742],
  [39.021534, -84.319985],
  [39.032476, -84.335727],
  [39.040727, -84.357822],
  [39.045829, -84.407334],
  [39.053042, -84.426256],
  [39.055579, -84.428564],
  [39.052874, -84.423789],
  [39.05874, -84.430561],
  [39.066834, -84.432732],
  [39.100885, -84.435388],
  [39.115293, -84.446389],
  [39.121479, -84.458818],
  [39.121668, -84.471177],
  [39.117536, -84.480511],
  [39.103001, -84.493945],
  [39.095177, -84.506161],
  [39.092272, -84.523772],
  [39.098998, -84.540342],
  [39.09936, -84.551359],
  [39.082745, -84.571101],
  [39.073294, -84.607889],
  [39.076544, -84.632506],
  [39.093897, -84.654339],
  [39.100802, -84.686073],
  [39.136616, -84.718096],
  [39.147557, -84.742785],
  [39.147223, -84.752734],
  [39.142905, -84.761062],
  [39.115313, -84.787768],
  [39.105489, -84.820157],
  [39.305153, -84.81945],
  [39.305044, -84.641814],
  [39.309746, -84.638589],
  [39.312056, -84.630047],
  [39.303257, -84.523544],
  [39.304835, -84.512774]
];



// WEBPACK FOOTER //
// ./src/lib/hamilton.js